import { useContext, useEffect } from 'react'
import { LoadingWrapperContext } from 'src/modules/core/context'
import { MeetRedirect } from 'src/modules/meet/containers'
import classes from './meet.module.scss'

export function Meet() {
  const { disableLoading } = useContext(LoadingWrapperContext)

  useEffect(() => {
    disableLoading()
  }, [disableLoading])

  return (
    <div className={classes.root}>
      <MeetRedirect />
    </div>
  )
}
